import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UserDialogView } from '../landing-page.modal';
import { ButtonTypes, CcdlButtonComponent } from '@cpm-pr1618001/ng-design-lib';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'header-ui',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [RouterLink, CcdlButtonComponent],
  standalone: true,
})
export class HeaderComponent implements OnChanges {
  @Output() userDialogViewEvent: EventEmitter<UserDialogView> =
    new EventEmitter<UserDialogView>();

  @Input() userDialogView: UserDialogView;
  showDialog: boolean = true;
  signInBtnType: ButtonTypes = 'default';
  signUpBtnType: ButtonTypes = 'default';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.updateActiveBtn();
    }
  }

  signInClick(): void {
    this.userDialogViewEvent.emit(UserDialogView.SIGN_IN);
    this.updateActiveBtn();
  }

  signUpClick(): void {
    this.userDialogViewEvent.emit(UserDialogView.SIGN_UP);
    this.updateActiveBtn();
  }

  updateActiveBtn(): void {
    this.signInBtnType =
      this.userDialogView === UserDialogView.SIGN_IN ? 'primary' : 'default';
    this.signUpBtnType =
      this.userDialogView === UserDialogView.SIGN_UP ? 'primary' : 'default';
  }

  onMobileMenu(): void {
    this.userDialogViewEvent.emit(UserDialogView.MOBILE_MENU);
  }
}
